import { useEffect, useState } from "react";
import { fetchSheetViaProxy } from "../lib/sheets";

function toInt(v) {
    const n = parseInt(String(v ?? "").trim(), 10);
    return Number.isFinite(n) ? n : null;
}

export default function RaceSessionSelect({
                                              valueRace,
                                              onRaceChange,
                                              valueSession,
                                              onSessionChange,
                                              showSession = true,
                                              onTrackLabelChange,
                                              valueClass,
                                              onClassChange,
                                              showClass = false,
                                              onUserRaceChange,
                                              autoSelectFirst = true,

                                              // ✅ neu
                                              sheetId,
                                              scheduleRange = "Schedule!A1:D",
                                              raceLabelPrefix = "R",
                                          }) {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const res = await fetchSheetViaProxy({
                    range: scheduleRange,
                    sheetId,
                });

                let matrix = [];
                if (Array.isArray(res?.values)) {
                    matrix = res.values;
                } else if (Array.isArray(res?.rows)) {
                    matrix = res.rows.map((r) => Object.values(r));
                }

                // Header entfernen, falls erste Zeile keine Rennnummer ist
                if (matrix.length && toInt(matrix[0]?.[0]) === null) {
                    matrix = matrix.slice(1);
                }

                const opts = matrix
                    .map((row) => {
                        const id = toInt(row?.[0]);
                        const track = String(row?.[1] ?? "").trim();
                        if (!id) return null;

                        return {
                            id,
                            track,
                            label: `${raceLabelPrefix}${id} – ${track}`,
                        };
                    })
                    .filter(Boolean)
                    .sort((a, b) => a.id - b.id);

                setOptions(opts);

                const current = opts.find((o) => o.id === valueRace) ?? opts[0];
                if (current) {
                    if (autoSelectFirst && typeof valueRace !== "number") {
                        onRaceChange?.(current.id);
                    }
                    onTrackLabelChange?.(current.label);
                }
            } catch (e) {
                console.warn("Schedule load failed", e);
                setOptions([]);
                onTrackLabelChange?.("");
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sheetId, scheduleRange]);

    const handleRaceChange = (id) => {
        onUserRaceChange?.(id);
        onRaceChange?.(id);

        const o = options.find((x) => x.id === id);
        onTrackLabelChange?.(o ? o.label : "");
    };

    return (
        <div className="card" style={{ display: "grid", gap: 8 }}>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <label className="rv-dd" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                    <span className="rv-dd__label">Rennen</span>
                    <select
                        className="rv-select rv-select--race"
                        value={valueRace ?? ""}
                        onChange={(e) => handleRaceChange(parseInt(e.target.value, 10))}
                    >
                        {options.map((o) => (
                            <option key={o.id} value={o.id}>
                                {o.label}
                            </option>
                        ))}
                    </select>
                </label>

                {showSession && (
                    <label className="rv-dd" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                        <span className="rv-dd__label">Session</span>
                        <select
                            className={`rv-select rv-select--${(valueSession ?? "RACE").toLowerCase()}`}
                            value={valueSession ?? "RACE"}
                            onChange={(e) => onSessionChange?.(e.target.value)}
                        >
                            <option value="RACE">RACE</option>
                            <option value="QUALY">QUALY</option>
                            <option value="PRACTICE">PRACTICE</option>
                        </select>
                    </label>
                )}

                {showClass && (
                    <label className="rv-dd" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                        <span className="rv-dd__label">Klasse</span>
                        <select
                            className={`rv-select rv-select--${(valueClass ?? "GESAMT").toLowerCase()}`}
                            value={valueClass ?? "GESAMT"}
                            onChange={(e) => onClassChange?.(e.target.value)}
                        >
                            <option value="GESAMT">Gesamt</option>
                            <option value="PRO">PRO</option>
                            <option value="INT">INT</option>
                            <option value="AM">AM</option>
                        </select>
                    </label>
                )}
            </div>
        </div>
    );
}